import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

registerLocaleData(localeRu, 'ru');
// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
